window.dataLayer = window.dataLayer || [];
function gtag() { window.dataLayer.push(arguments); }

gtag('js', new Date());
gtag('config', 'G-NB5JC7R8G7');

export const trackLoginSection = () => {
    gtag('event', 'page_view', {
        'page_title': 'Login',
        'page_path': '/login'
    });
}

export const trackCheckoutSection = () => {
    gtag('event', 'page_view', {
        'page_title': 'Checkout',
        'page_path': '/checkout'
    });
}

export const trackSignUp = (email, cuit) => {
    console.log("entro", email, cuit)
    gtag('event', 'sign_up', {
        method: "email", // Método utilizado para el registro (opcional)
        email: email,
        cuit: cuit
    });
}

export const trackAddToCart = (product, quantity) => {
    if (typeof gtag === 'function') {
        gtag('event', 'add_to_cart', {
            currency: "ARS",
            value: product.unitPrice,
            items: [
                {
                    item_id: product.productId,
                    item_name: product.productDescription,
                    price: product.unitPrice,
                    quantity: quantity,
                },
            ],
        });
    } else {
        console.log('gtag no está definido');
    }
};

export const trackBeginCheckout = (items, totalValue) => {
    gtag('event', 'begin_checkout', {
        currency: 'ARS', // Cambia a la moneda que uses, si es diferente
        value: totalValue, // Total de la compra
        items: items.map(item => ({
            item_id: item.productId,
            item_name: item.productDescription,
            price: item.unitPrice,
            quantity: item.quantity,
        }))
    });
}


export const trackPurchase = (transactionId, items, totalValue, tax) => {
    gtag('event', 'purchase', {
        transaction_id: transactionId, // ID único de la transacción
        affiliation: 'Pizzini Distribuidores', // Cambia al nombre de tu tienda
        value: totalValue, // Total de la compra (incluyendo impuestos y descuentos)
        currency: 'ARS', // Cambia si usas otra moneda
        tax: tax, // Impuestos
        shipping: "", // Costo de envío
        items: items.map(item => ({
            item_id: item.productId,
            item_name: item.productDescription,
            price: item.unitPrice,
            quantity: item.quantity,
        }))
    });
}


if (window.location.pathname === '/login') {
    trackLoginSection();
}

if (window.location.pathname === '/checkout') {
    trackCheckoutSection();
}